<template>
  <div class="full_page_loading">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  name: "full-page-loading"
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/general.sass"
</style>